import React from 'react'
import {Badge} from 'reactstrap'
import ErrorStatusBadge from './ErrorStatusBadge'
import './StatusBadge.css'

export default (props) => {
    switch(props.status) {
        case 'IN_PROGRESS':
            return <Badge className="status-badge" color="info">Em andamento</Badge>
        case 'SUCCESS':
            return <Badge className="status-badge" color="success">Sucesso</Badge>
        case 'ERROR':
            return <ErrorStatusBadge text={props.text}>Erro</ErrorStatusBadge>
        default:
            return <Badge className="status-badge"></Badge>
    }

}


// WEBPACK FOOTER //
// ./src/views/components/status-badge/StatusBadge.js